module.exports = __webpack_public_path__ + "img/logo-no-text.3a740a63.svg";